import { useCallback, useEffect, useRef, useState } from 'react';
import { Dimensions, View } from 'react-native';

const CHECK_INTERVAL_IN_MS = 250;
const OFFSET = 75;

const defaultOptions = {
	checkIntervalInMs: CHECK_INTERVAL_IN_MS,
	offset: OFFSET,
};

export const useInViewport = ({ checkIntervalInMs, offset } = defaultOptions) => {
	const ref = useRef<View>(null);
	const [isInView, setIsInView] = useState(false);

	const onLayout = useCallback(() => {
		if (!ref.current) {
			return;
		}

		ref.current.measure((x, y, width, height, pageX, top) => {
			const window = Dimensions.get('window');
			const topEdgeInViewRange = top > 0 && top <= window.height - offset;
			const bottomEdgeInViewRange = top < 0 && top >= -height + offset;

			const isInView = topEdgeInViewRange || bottomEdgeInViewRange;

			setIsInView(isInView);
		});
	}, [offset]);

	useEffect(() => {
		const intervalId = setInterval(onLayout, checkIntervalInMs);

		return () => clearInterval(intervalId);
	}, [checkIntervalInMs, onLayout]);

	return { isInView, ref, onLayout };
};
